module.exports = __webpack_public_path__ + "img/arrow-collapse-left.40fefbf3.svg";